import {Component} from '@angular/core';
import {PortalThemeModule} from '../../../@portal-theme/portal-theme.module';
import {SmartInsuranceConfirmModalResult} from '../smart-insurance-eligibility.types';

@Component({
    selector: 'app-smart-insurance-eligibility-confirm-modal',
    standalone: true,
    imports: [PortalThemeModule],
    templateUrl: './smart-insurance-eligibility-confirm-modal.component.html',
})
export class SmartInsuranceEligibilityConfirmModalComponent {
    modalDismiss: (event: Event, result: SmartInsuranceConfirmModalResult) => void;

    runSmartEligibilityCheck(event: Event, result: SmartInsuranceConfirmModalResult): void {
        this.modalDismiss(event, result);
    }
}
